module.exports = __webpack_public_path__ + "assets/login-321c8.2ae7db3.png";